<mat-icon
  *ngIf="required"
  i18n-matTooltip
  matTooltip="Required: This variable must be present in all records and will always be included in data outputs and packaging."
>
  grade</mat-icon
>
<mat-icon
  *ngIf="measure"
  i18n-matTooltip
  matTooltip="Measure: This variable can be aggregated (summed, averaged, etc) to arrive at some final result."
>
  straighten</mat-icon
>
<mat-icon
  *ngIf="weight"
  i18n-matTooltip
  matTooltip="Weight: This variable can be used to calculate the appropriate values for the entire population."
>
  fitness_center</mat-icon
>
